var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iframeGrid"},[_c('div',{attrs:{"id":"arrow-div"},on:{"click":_vm.backOnePage}},[_c('img',{attrs:{"id":"left-arrow","src":require("@/assets/leftarrow.png")}})]),_vm._v(" "),_c('div',{attrs:{"id":"iframe"}},[_c('iframe',{attrs:{"height":_vm.pageHeight,"width":_vm.pageWidth,"src":"static/scahill_project2.html"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98ceaa7c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NetworkJupyterNb.vue
// module id = null
// module chunks = 